
import { types } from "../types"


export const getProfile = () => {
    return {
        type: types.GET_PROFILE_REQUEST,

    }
}
export const resetPropsGetProfile = () => {
    return {
        type: types.GET_PROFILE_RESET_PROPS,

    }
}
export const resendMobileVerficationCode = (params) => {
    return {
        type: types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_REQUEST,
        params

    }
}
export const verifyMobile = (params) => {
    return {
        type: types.PROFILE_VERIFY_MOBILE_REQUEST,
        params
    }
}

export const getProvinceWithCity = (params) => {
    return {
        type: types.PROFILE_GET_PROVINCE_WITH_CITY_REQUEST,
        params
    }
}

export const save = (params) => {
    return {
        type: types.PROFILE_SAVE_REQUEST,
        params
    }
}

export const resendEmailVerfication = (params) => {
    return {
        type: types.RESEND_EMAIL_VERIFICATION_REQUEST,
        params
    }
}

export const changeEmailVerfication = (params) => {
    return {
        type: types.CHANGE_EMAIL_VERIFICATION_REQUEST,
        params
    }
}

export const changePassword = (params) => {
    return {
        type: types.PROFILE_CHANGE_PASSWORD_REQUEST,
        params
    }
}

export const resetChangePassword = (params) => {
    return {
        type: types.PROFILE_CHANGE_PASSWORD_RESET_PROPS,
        params
    }
}

export const addNewEmail = (params) => {
    return {
        type: types.ADD_NEW_EMAIL_REQUEST,
        params
    }
}

export const rejectNewEmail = (params) => {
    return {
        type: types.REJECT_NEW_EMAIL_REQUEST,
        params
    }
}

export const resetProfile = () => {
    return {
        type: types.RESET_PROFILE
    }
}






